import React, { useContext, useState, useEffect } from "react";
import { DashboardContext } from "../../context/DashboardContext";
import style from "./userProfile.module.css";
import { useNavigate } from "react-router-dom";

const UserProfile = () => {
  const { profile, updateProfile } = useContext(DashboardContext);
  const navigate = useNavigate()
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    phone: "",
    pan: "",
    a1: "",
    a2: "",
    a3: "",
    pincode: "",
    state: "",
    city: ""
  });

  // Load profile data into form when available
  useEffect(() => {
    if (profile) {
      console.log("profile data:", profile);
      setFormData({
        name: profile.name || "",
        email: profile.email || "",
        phone: profile.phone || "",
        pan: profile.pan || "",
        a1: profile.addrLine1 || "",
        a2: profile.addrLine2 || "",
        a3: profile.addrLine3 || "",
        pincode: profile.pincode || "",
        state: profile.state || "",
        city: profile.city || ""
      });
    }
  }, [profile]);

  // Handle input change
  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  // Handle submit
 const handleSubmit = async (e) => {
  console.log("rw1",formData);
  e.preventDefault();
    const originalProfile = {
    name: profile.name || "",
    email: profile.email || "",
    phone: profile.phone || "",
    pan: profile.pan || "",
    a1: profile.addrLine1 || "",
    a2: profile.addrLine2 || "",
    a3: profile.addrLine3 || "",
    pincode: profile.pincode || "",
    state: profile.state || "",
    city: profile.city || ""
  };

  const isSame = Object.keys(originalProfile).every(key => originalProfile[key] === formData[key]);

  if (isSame) {
    alert("Please make some changes before submitting.");
    return;
  }
  const result = await updateProfile(formData);
    console.log("rw",result);
  if (result.ok) {
    alert("Profile updated successfully!");
    navigate("/dashboard")
  } else {
    alert(`Update failed: ${result.message}`);
  }
};


  return (
    <div className={style.container}>
      <div className={style.titleContainer}>
        <h2 className={style.title}>Update Profile</h2>
        <button className={style.crossBtn} onClick={() => navigate(-1)}>
          &times;
        </button>
      </div>
      <form onSubmit={handleSubmit} className={style.form}>
        <div className={style.row}>
          <div>
            <label>Name</label>
            <input type="text" name="name" disabled value={formData.name} onChange={handleChange} />
          </div>
          <div>
            <label>Mobile Number</label>
            <input type="text" name="phone" disabled value={formData.phone} onChange={handleChange} />
          </div>
        </div>

        <div className={style.row}>
          <div>
            <label>Email</label>
            <input type="text" name="email" disabled value={formData.email} onChange={handleChange} />
          </div>
          <div>
            <label>PAN</label>
            <input type="text" name="pan" disabled value={formData.pan} onChange={handleChange} />
          </div>
        </div>

        <div className={style.row}>
          <div>
            <label>Street Name</label>
            <input type="text" name="a1" value={formData.a1} onChange={handleChange} />
          </div>
          <div>
            <label>Area Name</label>
            <input type="text" name="a2" value={formData.a2} onChange={handleChange} />
          </div>
        </div>

        <div className={style.row}>
          <div>
            <label>Address</label>
            <input type="text" name="a3" value={formData.a3} onChange={handleChange} />
          </div>
          <div>
            <label>PIN</label>
            <input type="number" name="pincode" value={formData.pincode} onChange={handleChange} />
          </div>
        </div>

        <div className={style.row}>
          <div>
            <label>State</label>
            <input type="text" name="state" value={formData.state} onChange={handleChange} />
          </div>
          <div>
            <label>City</label>
            <input type="text" name="city" value={formData.city} onChange={handleChange} />
          </div>
        </div>

        <button type="submit" className={style.submitBtn}>Submit</button>
      </form>
    </div>
  );
};

export default UserProfile;

